/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(
    [
        'jquery',
        'underscore',
        'assets/js/modules/View',
        'selectboxit/src/javascripts/jquery.selectBoxIt.min',
        'assets/js/modules/product/model/startFileModel',
        'assets/js/common/router/index',
        'assets/js/modules/product/model/attributeModel'
    ],
    function($, _, View, selectBoxIt, StartFileModel, router, AttributeModel) {
        var FOLDING_FILTERS = {
            'bi-fold': 'Bi-Fold',
            'tri-fold': 'Tri-Fold',
            'z-fold': 'Z-Fold'
        };

        return View.extend({
            events: {
                'change select': 'onChange'
            },

            initialize: function(options) {
                this.listenTo(this.model, 'change:startFile', this.render);

                this.$el.find('select').selectBoxIt();

                this.$products = this.$el.find('#start-file-size');
                this.$types = this.$el.find('#start-file-type');
                this.$folding = this.$el.find('#start-file-folding');
                this.$downloadButton = this.$el.find('#start-file-download');
                this.$specsShowLink = this.$el.find('#specs_show');
                this.$notFoundMessage = this.$el.find('#start-file-not-found');

                if (this.model.get('product')) {
                    this.model.set(
                        'startFile',
                        this.model
                            .get('product')
                            .get('startFiles')
                            .first()
                    );
                }
                this.renderProducts();
                this.render();
            },

            onChange: function() {
                this.model.trigger(
                    'StartFileWidget:change',
                    this.$products.val(),
                    new StartFileModel({
                        type: this.$types.val(),
                        filter: this.$folding.val() || null
                    })
                );
            },

            renderProducts: function() {
                var selectedProductSlug = this.model.get('product').get('slug');
                var productHtml = '';

                this.model.get('products').each(function(product) {
                    var selected = product.get('slug') === selectedProductSlug;
                    var name = product.getAttributeValue(AttributeModel.NAME_PRODUCT_SIZE_DESCRIPTION);

                    if (name === null) {
                        name = product.get('name');
                    }

                    productHtml += '<option value="' + product.get('slug') + '"' + (selected ? ' selected' : '') + '>' + name + '</option>';
                });
                this.$products.html(productHtml);
                this.$products.selectBoxIt('refresh');
                if (this.model.get('products').length === 1) {
                    this.$products.closest('.start-file-block').hide();
                }
            },

            render: function() {
                this.toggleNotFoundMessage();
                this.renderTypes();
                this.renderFolding();
                this.setDownloadPath();
                this.setSpecsShowLink();
            },

            toggleNotFoundMessage: function() {
                if (!this.model.get('startFile')) {
                    this.$notFoundMessage.closest('.start-file-block').show();
                } else {
                    this.$notFoundMessage.closest('.start-file-block').hide();
                }
            },

            renderTypes: function() {
                if (!this.model.get('startFile')) {
                    this.$types.closest('.start-file-block').hide();
                    return false;
                }
                var filteredModels = this.model
                    .get('product')
                    .get('startFiles')
                    .groupBy(function(model) {
                        return model.get('type');
                    });
                var typeSelected = this.model.get('startFile').get('type');
                var options = '';
                _.each(filteredModels, function(model, type) {
                    options += '<option value="' + type + '"' + (type === typeSelected ? ' selected' : '') + '>' + type + '</option>';
                });
                this.$types.html(options);
                this.$types.selectBoxIt('refresh');
                this.$types.closest('.start-file-block').show();
            },

            renderFolding: function() {
                var _this = this;
                var startFileSelected = this.model.get('startFile');
                if (!startFileSelected) {
                    this.$folding.closest('.start-file-block').hide();
                    return false;
                }
                var filteredModels = this.model
                    .get('product')
                    .get('startFiles')
                    .where({
                        type: this.model.get('startFile').get('type')
                    });
                var startFileWithFolding = _.find(filteredModels, function(startFile) {
                    return _this.isFoldingFilter(startFile.get('filter'));
                });
                if (!startFileWithFolding) {
                    this.$folding.closest('.start-file-block').hide();
                    return false;
                }
                filteredModels = _.groupBy(filteredModels, function(model) {
                    return model.get('filter');
                });
                var filterSelected = startFileSelected.get('filter');
                var options = '';
                _.each(filteredModels, function(model, filter) {
                    if (filter === 'null') {
                        options += '<option value=""' + (filter === filterSelected ? ' selected' : '') + '>No Folding</option>';
                    } else if (_this.isFoldingFilter(filter)) {
                        options +=
                            '<option value="' +
                            filter +
                            '"' +
                            (filter === filterSelected ? ' selected' : '') +
                            '>' +
                            FOLDING_FILTERS[filter] +
                            '</option>';
                    }
                });

                this.$folding.html(options);
                this.$folding.selectBoxIt('refresh');
                this.$folding.closest('.start-file-block').show();
            },

            setDownloadPath: function() {
                if (!this.model.get('startFile')) {
                    this.$downloadButton.closest('.start-file-block').hide();
                    return false;
                }
                this.$downloadButton.attr('href', this.model.get('startFile').get('url'));
                this.$downloadButton.closest('.start-file-block').show();
            },

            setSpecsShowLink: function() {
                this.$specsShowLink.attr(
                    'href',
                    router.generate('/file-specs/startfiles', { product: this.model.get('product').get('slug') })
                );
            },

            isFoldingFilter: function(filter) {
                return _.keys(FOLDING_FILTERS).indexOf(filter) !== -1;
            }
        });
    }
);
